import React from 'react';

export default class Scroll extends React.Component {
  constructor() {
    super();
    this.state = { xLoc: 0, yLoc: 0 };
    this.setScrollLocs = this.setScrollLocs.bind(this);
    this.changeScrollPosition = this.changeScrollPosition.bind(this);
  }

  componentDidMount() {
    window.addEventListener('scroll', this.setScrollLocs);
    this.setScrollLocs();
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.setScrollLocs);
  }

  setScrollLocs() {
    this.setState({ xLoc: window.scrollX, yLoc: window.scrollY });
  }

  changeScrollPosition(x, y) {
    window.scrollTo(x, y);
    this.setScrollLocs();
  }

  render() {
    const { xLoc, yLoc } = this.state;
    const { children } = this.props;

    return children({
      xLoc,
      yLoc,
      changeScrollPosition: this.changeScrollPosition,
    });
  }
}
